const en = {
  cards: {
    varoToAnyone: {
      title: 'Varo to Anyone',
      staticActionInitial: '+',
    },
    topPerk: {
      title: 'Rewards',
    },
    linkedAccountTile: {
      sectionTitle: 'Linked accounts',
      footerTitle: 'Manage external accounts',
    },
    checkingAccountTile: {
      title: 'Get started',
    },
  },
  progressTracker: {
    disclosureLink: 'Disclosures',
    issDDTrueDisclosureText: {
      one: '¹ Cashback is available on specific items or services purchased with your Varo Debit Card or Varo Believe Card at select brands/retailers. Offer details may vary, see the Perks tab for more details and current deals. The maximum Cashback that can be earned is seven-hundred and fifty dollars ($750 USD) per calendar month.',
      two: '² Varo Advance(VA) is a small dollar line of credit. Initial limits range from $20-$250, work your way up to $1,000 over time. Fees range from $1.60 - $100 based on loan amount. Quals Apply.',
    },
    issDDFalseDisclosureText: {
      one: '¹  We give access to direct deposits from employer & government payers on the day we receive them, typically up to 2 days earlier than your scheduled pay date.',
      two: '² Varo Advance(VA) is a small dollar line of credit. Initial limits range from $20-$250, work your way up to $1,000 over time. Fees range from $1.60 - $100 based on loan amount. Quals Apply.',
    },
    done: 'Done',
    isDDTrueSetupTitle: 'You’re all set up!',
    isDDTrueDescription:
      'Start earning up to 6% cashback on everyday purchases¹ and borrow up to $1,000 over time².',
    isDDFalseDescription:
      'Get paid up to 2 days early¹ and borrow up to $1,000 over time² when you move your paycheck to Varo.',
    setupDD: 'Set up direct deposit',
    disclosure: 'Disclosure',
    qualsApply: 'Quals apply. ',
  },
};
export default en;
